import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";
import { GetSigns } from "../../../store/sign-store/sign-actions";
import { signActions } from "../../../store/sign-store/sign-slice";
import { Button } from "primereact/button";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";
import { GetUserInfo } from "../../../store/user-store/user-actions";
import { GetStatusInfo } from "../../../store/status-store/status-actions";

const SignsHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const signs = useSelector((state) => state.sign.signs);
  const [completeSigns, setCompleteSigns] = useState([]);
  const [internalSigns, setInternalSigns] = useState([]);

  useEffect(() => {
    if (completeSigns && completeSigns.length > 0) {
      setInternalSigns(completeSigns.filter((u) => u.isIntern));
    }
  }, [completeSigns]);

  useEffect(() => {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("sign.showAll")
    ) {
      dispatch(GetSigns(userInfo.Email));
    } else if (
      userInfo.Roles !== undefined &&
      !userInfo.Roles.includes("sign.menu")
    ) {
      window.location.href = "/home";
    }
  }, [dispatch, userInfo.Email, userInfo.Roles]);

  useEffect(() => {
    if (completeSigns.length === 0 && signs !== undefined && signs.length > 0) {
      let cp = [];

      signs.forEach(async (sign) => {
        var representative = await dispatch(
          GetUserInfo(sign.representativeId, userInfo.Email)
        );
        var belonging = await dispatch(
          GetUserInfo(sign.belongingId, userInfo.Email)
        );
        var status = await dispatch(
          GetStatusInfo(sign.digitalSignStatusId, userInfo.Email)
        );

        cp.push({
          ...sign,
          representative: representative,
          belonging: belonging,
          digitalSignRegisterStatus: status,
        });

        if (cp.length === signs.length) {
          setCompleteSigns(cp);
        }
      });
      let x = [...signs];
      x.sort((a, b) => parseInt(a.pk) - parseInt(b.pk));
      setCompleteSigns(x);
      // setCompleteSigns(signs);
    }
  }, [completeSigns, dispatch, signs, userInfo.Email]);

  const viewDetailHanlder = (val) => {
    navigate(`/sign/detail/${val.pk}`);
  };
  const editHanlder = (val) => {
    navigate(`/sign/edit/${val.pk}`);
  };
  const createHanlder = () => {
    dispatch(
      signActions.setSign({
        sign: {
          id: 0,
          pk: "",
          instance: "",
          belongingId: 0,
          representativeId: 0,
          digitalsignstatusId: 0,
          razon: "",
          entity: "",
        },
      })
    );
    navigate(`/sign/users`);
  };

  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    // if (userInfo.Roles !== undefined && userInfo.Roles.includes("sign.edit")) {
    //   buttons.push(buttonEdit);
    // }
    if (userInfo.Roles !== undefined && userInfo.Roles.includes("sign.view")) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const statusBody = (rowData) => {
    if (
      rowData.digitalSignRegisterStatus !== undefined &&
      rowData.digitalSignRegisterStatus !== null &&
      rowData.digitalSignRegisterStatus.name !== undefined &&
      rowData.digitalSignRegisterStatus.name !== null &&
      rowData.digitalSignRegisterStatus.name !== ""
    ) {
      const color = rowData.digitalSignRegisterStatus.color;
      return (
        <span style={{ color: color, fontWeight: "bold" }}>
          {rowData.digitalSignRegisterStatus.name}
        </span>
      );
    } else {
      return (
        <i className="pi pi-spin pi-spinner" style={{ fontSize: "1rem" }}></i>
      );
    }
  };

  const columns = [
    {
      field: "pk",
      header: "Pk",
      filterMatchMode: "contains",
    },

    {
      field: "instance",
      header: "Instancia",
      filterMatchMode: "contains",
    },
    {
      field: "representative.name",
      header: "Solicitado por",
      filterMatchMode: "contains",
      body: (rowData) => {
        if (
          rowData.representative !== undefined &&
          rowData.representative !== null &&
          rowData.representative.name !== undefined &&
          rowData.representative.name !== null &&
          rowData.representative.name !== ""
        ) {
          return (
            rowData.representative.name + " " + rowData.representative.surname1
          );
        } else {
          return (
            <i
              className="pi pi-spin pi-spinner"
              style={{ fontSize: "1rem" }}
            ></i>
          );
        }
      },
    },
    {
      field: "belonging.name",
      header: "Para",
      filterMatchMode: "contains",
      body: (rowData) => {
        if (
          rowData.belonging !== undefined &&
          rowData.belonging !== null &&
          rowData.belonging.name !== undefined &&
          rowData.belonging.name !== null &&
          rowData.belonging.name !== ""
        ) {
          return rowData.belonging.name + " " + rowData.belonging.surname1;
        } else {
          return (
            <i
              className="pi pi-spin pi-spinner"
              style={{ fontSize: "1rem" }}
            ></i>
          );
        }
      },
    },
    {
      field: "digitalSignRegisterStatus.name",
      header: "Estado",
      filterMatchMode: "contains",
      body: statusBody,
    },
    {
      field: "razon",
      header: "Comentario",
      filterMatchMode: "contains",
    },
    {
      field: "creationDate",
      header: "Fecha de creación",
      filterMatchMode: "contains",
    },
  ];

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "118vh" }}
      >
        <ABADatatable
          width="0%"
          title="Certificados Internos"
          values={internalSigns}
          rows={5}
          rowsPerPageOptions={[5, 10, 20]}
          Columns={columns}
          actions={actions}
          createButton={{
            label: "Solicitar",
            onClick: createHanlder,
            permission: "sign.request",
          }}
          backButton={{
            label: "Regresar",
            onClick: backHanlder,
            permission: "goBack",
          }}
          sortField={"creationDate"}
        />
      </div>
    </>
  );
};
export default SignsHomePage;
